module.exports = __webpack_public_path__ + "static/media/potion-seller.b9459430.jpg";